// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import ApexCharts from 'react-apexcharts';
// import { BiFontSize } from 'react-icons/bi';

// const Dashboard = () => {
//   const [zoneTrainersCount, setZoneTrainersCount] = useState(0);
//   const [sparklineData, setSparklineData] = useState([]);

//   // Fetch Zone Trainers Count from the backend
//   useEffect(() => {
//     const fetchZoneTrainersCount = async () => {
//       try {
//         const response = await axios.get('/members/get_zone_trainers_count');
//         if (response.data.zone_trainers_count !== undefined) {
//           setZoneTrainersCount(response.data.zone_trainers_count);
//           // Example sparkline data
//           const data = [25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54]; // Example data
//           setSparklineData(data);
//         }
//       } catch (error) {
//         console.error('Error fetching Zone Trainers count:', error);
//       }
//     };

//     fetchZoneTrainersCount();
//   }, []);

//   const [activeMenu, setActiveMenu] = useState("");
//       useEffect(() => {
//         const profession_id = sessionStorage.getItem('profession_id');
//        // alert(profession_id)
//           if (profession_id  === "1") {
//             setActiveMenu('AdminApprovedZoneTrainer');

//           }else if (profession_id  === "2"){
//             setActiveMenu('AdminApprovedZoneTrainer');
//           }
//           else if (profession_id  === "3"){
//             setActiveMenu('lompresidentEventStatus');
//           }
//           else if (profession_id  === "3"){

//           setActiveMenu('trainersEventStatus');
//           }
//       }, []);

// const optionsSparkline = {
//     series: [
//       {
//         data: sparklineData,
//       },
//     ],
//     chart: {
//       type: 'line',
//       width: 100,
//       height: 35,
//       sparkline: {
//         enabled: true,
//       },
//     },
//     stroke: {
//       width: 3, // Increased stroke width to make the line bold
//       curve: 'smooth', // Smooth curve for the line
//     },
//     tooltip: {
//       fixed: {
//         enabled: false, // Disable fixed tooltips
//       },
//       x: {
//         show: false, // Disable X-axis values in the tooltip
//       },
//       y: {
//         title: {
//           formatter: function () {
//             return ''; // No tooltip title
//           },
//         },
//       },
//       marker: {
//         show: false, // Disable marker on hover
//       },
//     },
//     colors: ['white'], // Line color
//   };

//   return (
//     <div>

//     </div>
//     // <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 space-y-6 mb-10">
//     //   <div className="max-w-7xl mx-auto">
//     //     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
//     //       <div className="bg-gradient-to-r from-[#a9daff] to-[#0096d5] p-6 rounded-lg shadow-md flex items-center justify-between">
//     //         {/* Left Side: Zone Trainers Count and Name */}
//     //         <div className="text-left">
//     //           <p className="text-lg font-semibold text-white">Zone Trainers</p>
//     //           <p className="text-4xl font-bold text-white">{zoneTrainersCount}</p>
//     //         </div>

//     //         {/* Right Side: Sparkline Line Chart */}
//     //         <div className="ml-4">
//     //           <ApexCharts
//     //             options={optionsSparkline}
//     //             series={optionsSparkline.series}
//     //             type="line"
//     //             width={100}
//     //             height={35}
//     //           />
//     //         </div>
//     //       </div>
//     //     </div>
//     //   </div>
//     // </div>
//   );
// };

// export default Dashboard;

import React, { useState, useEffect } from "react";
import axios from "axios";
import ApexCharts from "react-apexcharts";
import { BiFontSize } from "react-icons/bi";

const Dashboard = () => {
  const [activeMenu, setActiveMenu] = useState("");
  useEffect(() => {
    const profession_id = sessionStorage.getItem("profession_id");
    // alert(profession_id)
    if (profession_id === "1") {
      setActiveMenu("/AdminApprovedZoneTrainer");
    } else if (profession_id === "2") {
      setActiveMenu("/AdminApprovedZoneTrainer");
    } else if (profession_id === "3") {
      setActiveMenu("/lompresidentEventStatus");
    } else if (profession_id === "3") {
      setActiveMenu("/trainersEventStatus");
    }
  }, []);

  return (
    <div>
      <h1>Dashboard</h1>
      {activeMenu && (
        <div className="menu-display">
          <p>
            The active menu is: <strong>{activeMenu}</strong>
          </p>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
